import React, { useState } from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { darkTheme } from '../../baseTheme/theme';
import StepForm from '../../components/form/OnboardingForm';
import StepProgress from '../../components/progressBar/OnboardingTopBar';
import Background from '../../components/background/OnboardingBackgound';

function Onboarding() {
  const [formData, setFormData] = useState({
    fullName: '',
    designation: '',
    companyName: '',
    email: '',
    phoneNumber: '',
    socials: {
      linkedin: false,
      instagram: false,
      discord: false
    },
    bio: ''
  });

  const [currentStep, setCurrentStep] = useState(0);
  const totalSteps = 7;

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSocialChange = (platform) => {
    setFormData(prev => ({
      ...prev,
      socials: {
        ...prev.socials,
        [platform]: !prev.socials[platform]
      }
    }));
  };

  const nextStep = () => {
    setCurrentStep(prev => Math.min(prev + 1, totalSteps - 1));
  };

  const prevStep = () => {
    setCurrentStep(prev => Math.max(prev - 1, 0));
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Background />
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 2,
          position: 'relative',
          zIndex: 2
        }}
      >
        <StepProgress currentStep={currentStep} totalSteps={totalSteps} />
        <StepForm
          formData={formData}
          currentStep={currentStep}
          handleChange={handleChange}
          handleSocialChange={handleSocialChange}
          nextStep={nextStep}
          prevStep={prevStep}
          totalSteps={totalSteps}
        />
      </Box>
    </ThemeProvider>
  );
}

export default Onboarding;